import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import { BasicSelect,ModelSelect} from 'vue-search-select';

export default {
  name: 'rtobagginghubdetails',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
    Multiselect
  },
  props: [],
  data() {
    return {
      hubzoneid: '',
      listHubZoneData: [],
      sourceHubId: [],
      listSourceHubNameData: [],
      destinationhub: [],
      destinationhublist: [],
      allHublist: [],
      HubArr: [],
      destData: [],
      connectionDestList: [],
      addmodalShow: false,
      checkAllHub:false,
      totalmappedhubs: 0,
      connDestLoading:false,
      useremail:'',
      zoneLoading:'',
      sourceHubLoading:'',
      modelArr: [],
      checked:[],
      allHubData:[],
      userData:[],
      isDisabled:false
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;
    this.userData = userdetail;
    this.getHubList();
    this.getHubZoneData();
  },
  methods: {
    getHubZoneData() {

      this.zoneLoading = 'Loading Zone...';
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let listHubZoneData = result.data.ResponseData;
            for (let i = 0; i < listHubZoneData.length; i++) {
              this.listHubZoneData.push({
                value: listHubZoneData[i].hubzoneid,
                text: listHubZoneData[i].hubzonename
              })
            }
          }
          this.zoneLoading = '';
        }, error => {
          this.zoneLoading = '';
          console.error(error);
        })
    },

    getHubList(filter) {
      this.sourceHubLoading = 'Loading Hub...'
      this.listSourceHubNameData = [];
      this.destinationhublist = [];
      this.allHublist = [];
      this.sourceHubId= [];

			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
        .then(result => {
          if (result.data.ResultCode == 100) {
						this.listSourceHubNameData = result.data.ResponseData.map(i => ({ text:i.HubName +' ('+i.HubID+')', value:i.HubID }));
						this.destinationhublist = result.data.ResponseData.map(i => ({ text:i.HubName +' ('+i.HubID+')', value:i.HubID }));
						this.allHublist = result.data.ResponseData.map(i => ({ text:i.HubName +' ('+i.HubID+')', value:i.HubID }));
          }
          this.sourceHubLoading = '';
          this.hubLoading = '';
        }, error => {
          this.sourceHubLoading = '';
          this.hubLoading = '';
          console.error(error)
        })
    },

		SelectSourceHub() {
			this.destinationhub= [];
			var a = this.sourceHubId.value
			this.destinationhublist = this.allHublist.filter(function(el) {
				return el.value != a
			});
		},

		SelectZone() {
			if (Object.keys(this.destinationhub).length <= 0 || Object.keys(this.sourceHubId).length <= 0){
				return false;
			}else{
				this.getDestinationsByConnection();
			}
		},

    onSubmit: function() {
      this.$validator.validateAll()
        .then((result) => {
          if (Object.keys(this.destinationhub).length <= 0 || Object.keys(this.sourceHubId).length <= 0){
            document.getElementById("dest").innerHTML= (Object.keys(this.destinationhub).length <= 0) ? 'The Destination Hub Name field is required.':'';
            document.getElementById("source").innerHTML= (Object.keys(this.sourceHubId).length <= 0) ? 'The Source Hub Name field is required.':'';
            return false;
          }

          if (!result) {
            console.log('errors exist', this.errors);
            return false;
          } else {
						this.hubzoneid = '',
            this.allHubData= [];
            this.getDestinationsByConnection();
          }
        }).catch(() => {
          console.log('parent search errors exist', this.errors);
        });
    },

    resetForm() {
      this.hubzoneid= '',
      this.sourceHubId= [],
      this.destinationhub= [],
      this.HubArr= [],
      this.modelArr= [],
      this.checked= [],
      this.allHubData= [];
      this.destData= [],
      this.connectionDestList= [],
      this.addmodalShow= false,
      this.checkAllHub= false,
      this.totalmappedhubs= 0,
      this.zoneLoading= '',
      this.sourceHubLoading= '',
      this.hubLoading= '',
      this.connDestLoading= false,
      this.isDisabled= false;
      document.getElementById("dest").innerHTML='',
      document.getElementById("source").innerHTML='',
      this.$validator.reset();
    },

    closeStatusModal() {
      this.addmodalShow = false
    },

    getDestinationsByConnection() {
      if (Object.keys(this.sourceHubId).length <= 0) { return false; }

      this.connDestLoading    = true;
      this.destData           = [];
      this.HubArr             = [];
      this.totalmappedhubs    = 0;
      this.checkAllHub        = false;
      this.isDisabled         = false;

			axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getAllocatedShipmentDestinationToBagDestination_V1?originHubId="+this.sourceHubId.value+"&bagDestinationHubId="+this.destinationhub.value+(this.hubzoneid ? "&hubzoneid="+this.hubzoneid : ''),
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isDisabled=true;
            let j=0; let list=[]; let dlist=[];
            let hData = result.data.ResponseData;
            for (var i = 0; i < hData.length; i++) {
              if(j<4){
                list.push({
                  hubId:hData[i].HubID,
                  hubName:hData[i].HubName
                });
              }else{
                dlist.push(list);
                list=[]
                list.push({
                  hubId:hData[i].HubID,
                  hubName:hData[i].HubName
                });
                j=0;
              }
              j++;

              if(hData[i].isHubSelected==true){
                this.HubArr.indexOf(hData[i].HubID) === -1 ? this.HubArr.push(hData[i].HubID):'';
                this.checked[hData[i].HubID] = true;
              }

              this.destData.push({
                hubId:hData[i].HubID,
                hubName:hData[i].HubName
              });

              const allH = this.allHubData.some(el => el.hubId === hData[i].HubID);
              if (!allH) {
                this.allHubData.push({
                  hubId:hData[i].HubID,
                  hubName:hData[i].HubName
                });
              }
            }
						this.modelArr = (this.modelArr.length>0) ? this.modelArr : this.HubArr;
            dlist.push(list);
            this.connectionDestList = dlist;
            this.totalmappedhubs  = result.data.TotalCount;
            if(this.HubArr.length == this.destData.length) this.checkAllHub = true;
          }else{
            this.$alertify.error(result.data.ReturnMessage, "", "error");
            this.isDisabled=false;
          }
          this.connDestLoading=false;
        }, error => {
          this.connDestLoading=false;
          console.error(error)
        })
   	},

   	checkHub() {
      if(typeof InstallTrigger !== 'undefined' == true){ this.checkAllHub = !this.checkAllHub; }
      this.HubArr = [];

      let nArr = [...new Set(this.destData.map(a => a.hubId))];

      if (this.checkAllHub) {
        for (var i = 0; i < this.destData.length; i++) {
          this.checked[this.destData[i].hubId]=true;
        }

        this.HubArr   = nArr;
        let arr       = [...this.modelArr, ...this.HubArr];
        this.modelArr = [...new Set(arr)];
      }else{
         for (var i = 0; i < this.destData.length; i++) {
           this.checked[this.destData[i].hubId]=false;
         }

         this.modelArr = this.modelArr.filter(val => !nArr.includes(val));
      }
   	},
    updateCheckDest(event){
     this.checked[event.target.id] = event.target.checked;

     if(event.target.checked==false){
       this.modelArr = this.modelArr.filter(el => el != event.target.id)

     }else{
       this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)):'';
     }

     this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
	 },

   	onSubmitHub: function(elem) {
     this.$validator.validateAll('hubsave').then((result) => {
       if (result) {
         if (Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.destinationhub).length <= 0 || this.modelArr.length <= 0) {
           this.$alertify.error('Hub selection or source/ destination hub should not be empty!'); return false;
         }else{
           this.addmodalShow = true
         }
       }else{
         return false;
       }
     }).catch(() => {});
   	},

   	mapMultipleHubsToConnection() {
     this.connDestLoading = true;
     let nArr = this.allHubData.filter((elem) => this.modelArr.find((el) => elem.hubId == el));
		 this.input = {
			 bagDestinationHubId: this.destinationhub.value,
			 bagDestinationHubName: this.destinationhub.text,
			 originHubId: this.sourceHubId.value,
			 originHubName: this.sourceHubId.text,
			 hubIdAndHubName: nArr,
			 createdBy: this.useremail
		 }
     axios({
         method: 'POST',
         'url': apiUrl.api_url_hubops + "allocateShipmentDestinationToBagDestination_V1",
         'data': this.input,
         headers: {
           'Authorization': "authkey xB84JJ89Hd25"
         }
       })
       .then(result => {
         if (result.data.ResultCode == 100) {
           this.$alert(result.data.ReturnMessage, "", "success");
           user_tracker.checkUserIP(this.userData[0], "RTObagginghubdetails", this.$route.path , this.input);
					 this.HubArr= []; this.hubzoneid = '';
           this.allHubData= []; this.modelArr= [];
           this.getDestinationsByConnection();
         } else {
           this.$alert(result.data.ReturnMessage, "", "error");
         }
         this.connDestLoading = false;
       }, error => {
         this.connDestLoading = false;
         console.error(error)
       })
   	},

   	takeAction() {
     this.mapMultipleHubsToConnection();
   	},
  }
}



// WEBPACK FOOTER //
// ./src/views/components/rtobagginghubdetails/rtobagginghubdetails.component.js